import { useNavigate } from 'react-router-dom'
import { BackButton } from '@twa-dev/sdk/react'

import { EventIcon } from 'components'
import { analyticsContext } from 'contexts'
import { FlexLayout } from 'layouts'
import { EventType } from 'types'

import './styles.scss'

const getDefaultSleepType = () => {
  const currentHour = new Date().getHours()

  if (currentHour >= 6 && currentHour < 20) {
    return EventType.SLEEP_DAY
  } else {
    return EventType.SLEEP_NIGHT
  }
}

const eventTypes = [
  {
    title: 'ГВ Левая',
    icon: 'BreastLeftIcon',
    type: EventType.BREAST_LEFT,
  },
  {
    title: 'ГВ Правая',
    icon: 'BreastRightIcon',
    type: EventType.BREAST_RIGHT,
  },
  {
    title: 'Бутылочка',
    icon: 'FeedBottleIcon',
    type: EventType.BOTTLE,
  },
  {
    title: 'Сон',
    icon: 'SleepIcon',
    type: getDefaultSleepType(),
  },
  {
    title: 'Ка-ка',
    icon: 'PoopIcon',
    type: EventType.POO,
  },
  {
    title: 'Пи-пи',
    icon: 'PeeIcon',
    type: EventType.PEE,
  },
]

export const CreateEvent = () => {
  const navigate = useNavigate()

  return (
    <FlexLayout.Container className="with-mobile-indent" vertical>
      <BackButton />
      <div className="page-title">Новая запись</div>
      <FlexLayout.Content className="scrollable-layout" scrollable>
        <div className="new-event-types">
          {eventTypes.map(({ title, icon, type }) => (
            <div
              className="event-type"
              key={title}
              onClick={() => {
                analyticsContext.trackEvent('event_selected', { event_name: type })

                navigate('/event/new', {
                  state: { type },
                })
              }}
            >
              <EventIcon
                iconName={icon}
                iconProps={{ width: 22, height: 22 }}
                width={39}
                height={39}
              />
              <div className="title">{title}</div>
            </div>
          ))}
        </div>
      </FlexLayout.Content>
    </FlexLayout.Container>
  )
}
